import React, { useEffect, useState } from 'react';
import '../assets/css/ProfileStatus.css'

const ProfileStatus = ({
  label,
  numbers,
  icon,
  percentage = 0,
  iconColor,
  bgColor,
  circleColor,
  widths = '285px',
  height = '90px',
  transactios,
  amountsData,
  showCircle = true   // ✅ new prop, default true
}) => {





  return (
    <div className="progress-card col-sm-2" style={{ backgroundColor: bgColor, width: widths, height }}>
      <div style={{ display: "flex", alignItems: 'center' }}>
        <div
          style={{
            height: '44px',
            width: '44px',
            borderRadius: '22px',
            display: 'flex',
            alignItems: 'center',
            background: bgColor,
            justifyContent: 'center',
            marginRight: "20px"
          }}
        >
          <img src={icon} alt={label} className="progress-card-icon" />
        </div>
        <div className="progress-card-label">
          <p className='m-0' style={{ color: iconColor, fontSize: '30px', fontWeight: '500' }}>
            {numbers}
          </p>
          <p className='m-0' style={{ color: iconColor, fontSize: '14px', fontWeight: '500' }}>
            {label}
          </p>
          <p className='m-0' style={{ color: iconColor, fontSize: '14px', fontWeight: '500' }}>
            {transactios && <span>Total amount :₹ {transactios}</span>}
            {amountsData && <span>₹  {amountsData}</span>}
          </p>
        </div>
      </div>

      {/* ✅ Only show if showCircle is true */}

      {/* {showCircle && (
        <div className="progress-card-body">
          <div className="circle">
            <svg width="50" height="50" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
              <circle cx="40" cy="40" r="35" stroke="#ddd" strokeWidth="7" fill="none" />
              <circle
                cx="40"
                cy="40"
                r="35"
                stroke={circleColor}
                strokeWidth="5"
                fill="none"
                strokeDasharray={`${(percentage * 2.2)} 220`}
                strokeLinecap="round"
              />
            </svg>
            <div className="percentage" style={{ color: iconColor }}>
              {percentage}%
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default ProfileStatus;
